import { getAppSchema } from "../Client/Schema"
import { SortExpression } from "../Client/SortExpression"
import { MetricQualityObject } from "../DataProgram/Measurement"
import { APIAppInstanceModel } from "./AppInstanceModel"
import { APIAppTemplateModel } from "./AppTemplateModel"

export type APIGroundTruthType = "REVIEW" | "GOLD_WORKFLOW" | "OWNER"

export interface APIGroundTruthModel {
    id: number
    jobId: number
    ownerId: number
    used: number
    status: "ACTIVE"
    created: string
    input: any
    tag?: string
    type: APIGroundTruthType
    baselineQuality?: MetricQualityObject | null
}

export type APIGroundTruthDetailedModel = APIGroundTruthModel & {
    label: unknown
}

export function getGroundTruthID(model: APIGroundTruthModel): string {
    return String(model.id)
}

export const defaultGroundTruthSort: SortExpression<APIGroundTruthModel> = {
    sortBy: "created",
    desc: true
}

export function getSchemaFormData(
    groundTruth: APIGroundTruthDetailedModel,
    instance: APIAppInstanceModel,
    template: APIAppTemplateModel
) {
    const schema = getAppSchema(instance, template, false)

    return {
        input: { ...schema.input, formData: groundTruth.input },
        output: { ...schema.output, formData: groundTruth.label }
    }
}

export function getSchemaFormattedFormData(
    groundTruth: APIGroundTruthDetailedModel,
    instance: APIAppInstanceModel,
    template: APIAppTemplateModel
) {
    return {
        input: {
            schema: instance.inputSchema ?? template.inputSchema,
            uiSchema: instance.inputUiSchema ?? template.inputUiSchema ?? {},
            formData: groundTruth.input
        },
        output: {
            schema: instance.outputSchema ?? template.outputSchema,
            uiSchema: instance.outputUiSchema ?? template.outputUiSchema ?? {},
            formData: groundTruth.label
        }
    }
}
